const STATUS_STYLES = {
  trial: 'bg-primary/10 text-primary',
  active: 'bg-green-950/30 text-green-400',
  suspended: 'bg-red-950/30 text-red-400',
  grace_period: 'bg-yellow-950/30 text-yellow-400',
  cancelled: 'bg-muted text-foreground',
};

const STATUS_LABELS = {
  trial: 'Essai',
  active: 'Actif',
  suspended: 'Suspendu',
  grace_period: 'Grace',
  cancelled: 'Annule',
};

const OrgStatusBadge = ({ status, small = false }) => (
  <span className={`font-medium rounded-full ${small ? 'px-2 py-1 text-xs' : 'px-3 py-1 text-sm'} ${STATUS_STYLES[status] || 'bg-muted'}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export default OrgStatusBadge;
